<template>
  <router-view />
</template>

<script setup lang="ts">
import { useColorScheme } from '@/composables/ui/useColorScheme'

// Initialize color scheme (dark mode)
useColorScheme()

// Note: Page title is now managed by router.afterEach() in router/index.ts
// This ensures the title updates dynamically based on the current route
</script>

<style>
/* Global styles */
html {
  font-family: var(--brand-font-family, 'Poppins', sans-serif);
}

body {
  font-family: var(--brand-font-family, 'Poppins', sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Dark mode styles */
.dark {
  color-scheme: dark;
}

/* Color scheme transitions */
* {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
</style>